/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MetaformFieldType,
    MetaformFieldTypeFromJSON,
    MetaformFieldTypeFromJSONTyped,
    MetaformFieldTypeToJSON,
    ReplySummaryOption,
    ReplySummaryOptionFromJSON,
    ReplySummaryOptionFromJSONTyped,
    ReplySummaryOptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReplySummaryField
 */
export interface ReplySummaryField {
    /**
     * 
     * @type {string}
     * @memberof ReplySummaryField
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplySummaryField
     */
    title?: string;
    /**
     * 
     * @type {MetaformFieldType}
     * @memberof ReplySummaryField
     */
    type?: MetaformFieldType;
    /**
     * 
     * @type {number}
     * @memberof ReplySummaryField
     */
    answerCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ReplySummaryField
     */
    average?: number;
    /**
     * 
     * @type {Array<ReplySummaryOption>}
     * @memberof ReplySummaryField
     */
    options?: Array<ReplySummaryOption>;
    /**
     * Most recent free text answers of the field, capped to a fixed maximum
     * @type {Array<string>}
     * @memberof ReplySummaryField
     */
    textAnswers?: Array<string>;
}

export function ReplySummaryFieldFromJSON(json: any): ReplySummaryField {
    return ReplySummaryFieldFromJSONTyped(json, false);
}

export function ReplySummaryFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplySummaryField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'type': !exists(json, 'type') ? undefined : MetaformFieldTypeFromJSON(json['type']),
        'answerCount': !exists(json, 'answerCount') ? undefined : json['answerCount'],
        'average': !exists(json, 'average') ? undefined : json['average'],
        'options': !exists(json, 'options') ? undefined : ((json['options'] as Array<any>).map(ReplySummaryOptionFromJSON)),
        'textAnswers': !exists(json, 'textAnswers') ? undefined : json['textAnswers'],
    };
}

export function ReplySummaryFieldToJSON(value?: ReplySummaryField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'title': value.title,
        'type': MetaformFieldTypeToJSON(value.type),
        'answerCount': value.answerCount,
        'average': value.average,
        'options': value.options === undefined ? undefined : ((value.options as Array<any>).map(ReplySummaryOptionToJSON)),
        'textAnswers': value.textAnswers,
    };
}


